var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaroselStarSlide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 446,
    height: 779,
    viewBox: "0 0 446 779",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320.722 287.593C320.722 287.593 311.645 283.813 294.462 279.156C294.426 279.144 294.991 251.604 294.539 249.097C293.347 249.823 292.586 251.951 292.586 251.951C292.586 251.951 287.681 276.843 287.578 277.216C273.02 274.072 259.055 271.531 242.554 268.744C242.288 269.307 270.893 279.552 285.639 284.221C285.295 285.449 276.668 308.71 275.825 311.644C275.793 313.281 276.55 313.814 276.55 313.814C276.55 313.814 292.178 286.901 292.533 285.697C310.36 289.753 319.277 291.183 319.277 291.183C330.735 292.473 320.728 287.574 320.728 287.574",
    fill: "#E6FFF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190.439 265.476C47.636 256.382 -141.147 357.393 -197.31 560.679L-179.218 560.374C-155.882 423.405 17.3757 239.653 235.812 270.341C230.35 267.061 196.6 265.815 190.439 265.476Z",
    fill: "#E6FFF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaroselStarSlide);
export default __webpack_public_path__ + "static/media/carosel-star-slide.466854636d1d17715fc9c8da2cbaeca5.svg";
export { ForwardRef as ReactComponent };